export default __webpack_public_path__ + "static/media/menu.80e04816.svg";